<template>
  <div class="flex items-start">
    <FormKit type="checkbox" v-model="model" />
    I understand that the 64 Analytics Portal pass is a one-time payment in
    exchange for services lasting until {{ endDate }}
  </div>
</template>

<script lang="ts" setup>
const model = defineModel<boolean>();

const props = withDefaults(
  defineProps<{
    portalPassSeasons: number;
  }>(),
  {
    portalPassSeasons: 1,
  }
);

// end date in format MM d, yyyy
// 1 season: January 31, 2026
// 2 seasons: January 31, 2027
// 3 seasons: January 31, 2028
const endDate = computed(() => {
  if (props.portalPassSeasons == 1) {
    return 'January 31, 2026';
  } else if (props.portalPassSeasons == 2) {
    return 'January 31, 2027';
  } else if (props.portalPassSeasons == 3) {
    return 'January 31, 2028';
  }
});
</script>
